<template>
    <div>
      <Pos_bill_after/>
    </div>
  </template>
  
  <script>
  import Pos_bill_after from "@/components/adminArin/pos_system/pos/Pos_bill_after";
  export default {
    name: "PosBillAfter",
    components: {
      Pos_bill_after
    }
  }
  </script>
  
  <style scoped>
  
  </style>
  